import { Value } from '@philips-internal/oswald-ui-core';

interface LogApprovalProcessRequest {
  approvalSequence: number | string,
  approvalProcessSequence: number | string
  startLogDate: moment.Moment,
  event: string,
  logDescription: string
}

interface FormData extends LogApprovalProcessRequest, Record<string, Value> {}

const normalizeLogApprovalProcessBody = (approvalSequence: number | string, approvalProcessSequence: number | string, startLogDate: moment.Moment, event: string, logDescription: string): FormData => ({
  approvalSequence,
  approvalProcessSequence,
  startLogDate,
  event,
  logDescription,
});
  
export {
  normalizeLogApprovalProcessBody,
};
